const actions = {
  listarRiscos: async (
    context,
    { vendorId, page, perPage, name, code, deleted }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`risk`, {
      params: { vendorId, page, perPage, name, code, deleted },
    });
    return response;
  },

  criarRisco: async (context, { name, code, vendorId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`risk`, { name, code, vendorId });
    return response;
  },

  editarRisco: async (context, { id, name, code, vendorId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`risk/${id}`, { name, code, vendorId });
    return response;
  },

  deletarRisco: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`risk/${id}`);
    return response;
  },

  vincularRiscoCA: async (
    context,
    { id, riskControlType, riskControlExternalId }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`risk/${id}/link`, {
      riskControlType,
      riskControlExternalId,
    });
    return response;
  },

  desvincularRiscoCA: async (context, { id, riskControl }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`risk/${id}/unlink/${riskControl}`, {});
    return response;
  },

  listarVinculosRisco: async (
    context,
    { vendorId, controlType, controlSearch, search, page, perPage }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`risk/link`, {
      params: { vendorId, controlType, controlSearch, search, page, perPage },
    });
    return response;
  },

  listarCAs: async (context, { code, page, per_page, status } = {}) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cas`, {
      params: { code, page, per_page, status },
    });
    return response;
  },

  relatorioRiscos: async (context, { status, vendorId } = {}) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`risk/report`, {
      params: { status, vendorId },
    });
    return response;
  },

  listarHistoricoRisco: async (context, { riskId, page, perPage } = {}) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`risk/history`, {
      params: { riskId, page, perPage },
    });
    return response;
  },

  relatorioVinculos: async (
    context,
    { controlType, controlSearch, search } = {}
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`risk/link-report`, {
      params: { controlType, controlSearch, search },
    });
    return response;
  },

  listarProdutosCA: async (
    context,
    { contract_id, ca_code, per_page = 100, page = 1 } = {}
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`contracts/${contract_id}/products`, {
      params: { per_page, page, search: "", ca_status: "", ca_code },
    });
    return response;
  },
};

export const gestaoDeRiscos = {
  namespaced: true,
  actions,
};
